import { type ChartOptions, ColorType, CrosshairMode, type DeepPartial } from "lightweight-charts"

export const UP = "#26a69a"
export const DOWN = "#ef5350"
export const UP_VOLUME = "rgba(38, 166, 154, 0.45)"
export const DOWN_VOLUME = "rgba(239, 83, 80, 0.45)"

export const CHART_OPTIONS: DeepPartial<ChartOptions> = {
  autoSize: true,
  layout: {
    // Internal app: the attribution notice lives in THIRD_PARTY_NOTICES.md instead.
    attributionLogo: false,
    background: { type: ColorType.Solid, color: "#131722" },
    textColor: "#b2b5be",
    fontFamily: "ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
    fontSize: 11
  },
  grid: { vertLines: { color: "#1e222d" }, horzLines: { color: "#1e222d" } },
  crosshair: { mode: CrosshairMode.Normal },
  rightPriceScale: { borderColor: "#2a2e39" },
  timeScale: { borderColor: "#2a2e39", rightOffset: 6 }
}

export const CANDLE_OPTIONS = {
  upColor: UP,
  downColor: DOWN,
  borderUpColor: UP,
  borderDownColor: DOWN,
  wickUpColor: UP,
  wickDownColor: DOWN
}

/** Volume sits at the bottom fifth of the price pane, on its own scale. */
export const VOLUME_OPTIONS = {
  priceScaleId: "volume",
  priceFormat: { type: "volume" as const },
  lastValueVisible: false,
  priceLineVisible: false
}
